export const unityLoadingOff = (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  (window as { [key: string]: any })["loading_off"] = () => {
    console.log("loading off");

    setLoading(false);
  };
};
